// 0 = full-size
export type YoutubeThumbnailQuality = '0' | '1' | '2' | '3'
    | 'default' | 'hqdefault' | 'mqdefault' | 'sddefault' | 'maxresdefault';

export type VimeoThumbnailQuality = 'small' | 'medium' | 'large';

export function getYoutubeThumbnailUrl(videoId: string, parameters?: { quality: YoutubeThumbnailQuality }) {
    const quality = parameters?.quality ?? '0';

    return `//img.youtube.com/vi/${videoId}/${quality}.jpg`;
}

export async function getVimeoThumbnailUrl(videoId: string, parameters?: { quality: VimeoThumbnailQuality }) {
    const quality = parameters?.quality ?? 'large';

    const response = await fetch(`//vimeo.com/api/v2/video/${videoId}.json`);
    const data = await response.json();
    const thumbnailUrl = data[0][`thumbnail_${quality}`];
    if (!thumbnailUrl) {
        throw new Error(`Vimeo returned incorrect thumbnail data for video: ${videoId}`);
    }
    return thumbnailUrl;
}

export async function getThumbnailUrl(service: string, videoId: string) {
    if (service === 'youtube') {
        return getYoutubeThumbnailUrl(videoId);
    }
    if (service === 'vimeo') {
        const result = await getVimeoThumbnailUrl(videoId);
        return result;
    }
    throw new Error(`Unsupported video service: ${service}`);
}
